(function () {
  function norm(s) {
    return (s || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  function ensureStyle() {
    if (document.getElementById("fb-qs-style")) return;
    var st = document.createElement("style");
    st.id = "fb-qs-style";
    st.textContent = ".fb-qs-hidden{display:none!important}";
    document.head.appendChild(st);
  }

  function findScope(root) {
    var start = root.closest(".shopify-section") || root.parentElement;
    var el = start ? start.nextElementSibling : null;
    var i = 0;
    while (el && i < 60) {
      if (el.querySelector && el.querySelectorAll("h3").length >= 6) return el;
      el = el.nextElementSibling;
      i++;
    }
    return document.querySelector("main") || document;
  }

  // 找到“包含全部 h3 的最小共同容器”，且它的直接子元素数量合理（像 22 张卡片）
  function findContainer(heads) {
    if (!heads.length) return null;

    // 收集第一个 h3 的祖先链
    var chain = [];
    var n = heads[0];
    var depth = 0;
    while (n && depth < 25) {
      chain.push(n);
      n = n.parentElement;
      depth++;
    }

    // 从近到远找一个节点：能包含所有 heads，且 children 数在合理范围
    for (var i = 0; i < chain.length; i++) {
      var cand = chain[i];
      var okAll = true;
      for (var k = 0; k < heads.length; k++) {
        if (!cand.contains(heads[k])) { okAll = false; break; }
      }
      if (!okAll) continue;

      var c = cand.children ? cand.children.length : 0;
      if (c >= 6 && c <= 80) return cand;
    }

    return null;
  }

  // 给定 container + 一个 h3，返回“container 的直接子元素中包含该 h3 的那个子元素”
  function cardFromHeading(container, h) {
    if (!container || !h) return null;
    var n = h;
    var guard = 0;
    while (n && n.parentElement !== container && guard < 20) {
      n = n.parentElement;
      guard++;
    }
    return (n && n.parentElement === container) ? n : null;
  }

  function bind(root) {
    ensureStyle();

    var input = root.querySelector("input[data-fb-qs-input]");
    var btn = root.querySelector("button[data-fb-qs-btn]");
    var dbg = root.querySelector("[data-fb-qs-debug]");
    if (!input || !btn) return;

    function apply() {
      var scope = findScope(root);
      var heads = Array.prototype.slice.call(scope.querySelectorAll("h3"));
      var container = findContainer(heads);

      // 如果找不到 container，就直接不动（避免误伤）
      if (!container) {
        if (dbg) dbg.textContent = "Found: 0";
        return;
      }

      // 构建卡片列表（container 的直接子元素）
      var cards = [];
      for (var i = 0; i < heads.length; i++) {
        var card = cardFromHeading(container, heads[i]);
        if (card && cards.indexOf(card) === -1) cards.push(card);
      }

      if (dbg) dbg.textContent = "Found: " + cards.length;

      var q = norm(input.value);

      if (!q) {
        cards.forEach(function (c) { c.classList.remove("fb-qs-hidden"); });
        return;
      }

      cards.forEach(function (c) {
        var text = norm(c.innerText || c.textContent);
        if (text.indexOf(q) !== -1) c.classList.remove("fb-qs-hidden");
        else c.classList.add("fb-qs-hidden");
      });
    }

    input.addEventListener("input", apply);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); apply(); }
    });
    btn.addEventListener("click", apply);

    var tries = 0;
    var t = setInterval(function () {
      tries++;
      apply();
      if (tries >= 60) clearInterval(t);
    }, 250);
  }

  function boot() {
    var roots = document.querySelectorAll("[data-fb-qs-root]");
    roots.forEach(function (r) { bind(r); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:reorder", boot);
})();
